export default "__VITE_ASSET__C61doQRb__"